import { get, post } from '../request';
import { APP_CONFIG } from '../../config';
import { getLogger } from '../../utils/logger/logger';
import { NotLoggedInError } from '../../domain/errors/NotLoggedInError';
import { UserInteraction } from '../../@types/userInteraction';
import { UserInteractionStatus } from '../../@types/benefitsViewedStatus';
import { userInteractionStatusToApp } from './converter/userInteractionStatus';
import { ApiEndpoints } from '../apiEndpoints.constant';

export const saveUserInteraction = async (userInteraction: UserInteraction): Promise<void> => {
  try {
    await post(`${APP_CONFIG.apiEndpoint}/user-interactions/my`, userInteraction);
  } catch (error) {
    if (error instanceof NotLoggedInError) {
      getLogger('saveUserInteraction').info('User is not logged in.');
    } else {
      getLogger('saveUserInteraction').error(`Api object: ${JSON.stringify(userInteraction)}`, { error });
    }
    // we want to ignore all errors to not disrupt the user flow
    return;
  }
};

export const getUserInteractions = async (): Promise<UserInteractionStatus> => {
  return userInteractionStatusToApp(await get(`${APP_CONFIG.apiEndpoint}${ApiEndpoints.userInteractions}`));
};
